// namespace
export const STORE_NAMESPACE = 'admins'

// actions
export const FETCH_ALL = 'fetchAll'
export const CREATE = 'create'
export const UPDATE = 'update'
export const DELETE = 'delete'
export const UPDATE_FIELD = 'updateField'
export const FETCH_STATUSES = 'fetchStatuses'

// mutations
export const SET_ADMIN_LIST = 'SET_ADMIN_LIST'

// getters
